module.exports = __webpack_public_path__ + "img/milestone_icon@3x.2f1427b8.png";